import { createMuiTheme, darken, lighten } from "@material-ui/core";
import { corporate } from "./colors";

export * from "./colors";

const themeSpacing = 8;

export const createTheme = () => {
  return createMuiTheme({
    spacing: themeSpacing,
    zIndex: {
      appBar: 1100,
      modal: 1250,
      drawer: 1200,
      snackbar: 1400,
      tooltip: 1500
    },
    overrides: {
      MuiPopover: {
        root: {
          "z-index": "1300 !important"
        }
      },
      MuiTooltip: {
        tooltip: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
        arrow: {
          "&::before": {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            border: "0px"
          }
        },
      },
      MuiDialogTitle: {
        root: {
          padding: `${themeSpacing}px`,
          '& h2': {
            fontSize: "1.0rem !important"
          }
        }
      },
      MuiDialogContent: {
        root: {
          padding: `${2*themeSpacing}px`,
        }
      },
      MuiIconButton: {
        root: {
          padding: `${themeSpacing}px`
        }
      }
    },
    palette: {
      primary: {
        main: corporate.blue,
        light: lighten(corporate.blue, 0.25),
        dark: darken(corporate.blue, 0.25)
      },
      secondary: {
        main: corporate.red,
        light: lighten(corporate.red, 0.25),
        dark: darken(corporate.red, 0.25)
      }
    },
    mixins: {
      toolbar: {
        // override default
      }
    }
  });
};
